import React from 'react'
import Link from 'gatsby-link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeOpen, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faYoutubeSquare} from '@fortawesome/free-brands-svg-icons'

const Footer = () => (
    <footer className="footer m-t-xl has-background-primary">
        <div className="columns">
            
            <div className="column">
                <div className="content has-text-white footer-list">
                    <h3 className="has-text-white">Contact Us</h3>
                    <p><FontAwesomeIcon icon={faEnvelopeOpen} size="1x" /> customercare@backyardbundles.com</p>    
                </div>
            </div>
            <div className="column">
                <div className="content">

                </div>
            </div>
            <div className="column">
                <div className="content has-text-white">
                    <h3 className="has-text-white">Connect</h3>
                    <span className="m-r-lg">
                        <FontAwesomeIcon icon={faFacebook} size="2x" /> 
                    </span>
                    <span className="m-r-lg">
                        <FontAwesomeIcon icon={faInstagram} size="2x" />
                    </span>
                </div>
            </div>
            
        </div>
        <div className="content has-text-centered">
            <p className="has-text-white">
               &copy; 2018 Backyard Bundles - All Rights Reserved
            </p>
        </div>
    </footer>
)

export default Footer


// WEBPACK FOOTER //
// ./src/components/footer.js